import { AIKitApiClient } from '@fourthwall/services/dist/AIKitApiClient'
import { AgencyApiClient } from '@fourthwall/services/dist/AgencyApiClient'
import { AnalyticsApiClient } from '@fourthwall/services/dist/AnalyticsApiClient'
import { BespokeProductsApiClient } from '@fourthwall/services/dist/BespokeProductsApiClient'
import { BillingApiClient } from '@fourthwall/services/dist/BillingApiClient'
import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { CreatorIntegrationsV2ApiClient } from '@fourthwall/services/dist/CreatorIntegrationsV2ApiClient'
import { CreatorMobilizationApiClient } from '@fourthwall/services/dist/CreatorMobilizationApiClient'
import { CreatorSupportChannelsApiClient } from '@fourthwall/services/dist/CreatorSupportApiClient'
import { CustomizationApiClient } from '@fourthwall/services/dist/CustomizationApiClient'
import { CustomizationV4ApiClient } from '@fourthwall/services/dist/CustomizationV4ApiClient'
import { DashboardApiClient } from '@fourthwall/services/dist/DashboardApiClient'
import { DashboardV2ApiClient } from '@fourthwall/services/dist/DashboardV2ApiClient'
import { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient'
import { DonationApiClient } from '@fourthwall/services/dist/DonationApiClient'
import { FulfillmentsApiClient } from '@fourthwall/services/dist/FulfillmentsApiClient'
import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { GiftsApiClient } from '@fourthwall/services/dist/GiftsApiClient'
import { GiveawayConfigApiClient } from '@fourthwall/services/dist/GiveawayConfigApiClient'
import { GiveawayContributionApiClient } from '@fourthwall/services/dist/GiveawayContributionApiClient'
import { GoogleAnalyticsConfigurationApiClient } from '@fourthwall/services/dist/GoogleAnalyticsConfigurationApiClient'
import { HarmonisedSystemCodeApiClient } from '@fourthwall/services/dist/HarmonisedSystemCodeApiClient'
import { HasuraApiClient } from '@fourthwall/services/dist/HasuraApiClient'
import { InternalApiClient } from '@fourthwall/services/dist/InternalApiClient'
import { KudosApiClient } from '@fourthwall/services/dist/KudosApiClient'
import { MembershipsApiClient } from '@fourthwall/services/dist/MembershipsApiClient'
import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { MembershipsDirectMessagesApiClient } from '@fourthwall/services/dist/MembershipsDirectMessagesApiClient'
import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { MetaConversionsApiClient } from '@fourthwall/services/dist/MetaConversionsApiClient'
import { MetaPartnerApiClient } from '@fourthwall/services/dist/MetaPartnerApiClient'
import { MetaPartnerProductsApiClient } from '@fourthwall/services/dist/MetaPartnerProductsApiClient'
import { NotificationPreferencesApiClient } from '@fourthwall/services/dist/NotificationPreferencesApiClient'
import { NotificationShopPreferencesApiClient } from '@fourthwall/services/dist/NotificationShopPreferencesApiClient'
import { OfferCategoryApiClient } from '@fourthwall/services/dist/OfferCategoryApiClient'
import { OfferListingApiClient } from '@fourthwall/services/dist/OfferListingApiClient'
import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { OffersBundleApiClient } from '@fourthwall/services/dist/OffersBundleApiClient'
import { OffersCombinedApiClient } from '@fourthwall/services/dist/OffersCombinedApiClient'
import { OffersGiftCardApiClient } from '@fourthwall/services/dist/OffersGiftCardApiClient'
import { OffersV2ApiClient } from '@fourthwall/services/dist/OffersV2ApiClient'
import { OnboardingApiClient } from '@fourthwall/services/dist/OnboardingApiClient'
import { OpenAPIApiClient } from '@fourthwall/services/dist/OpenAPIApiClient'
import { OrderAnalyticsApiClient } from '@fourthwall/services/dist/OrderAnalyticsApiClient'
import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { PaidDomainsApiClient } from '@fourthwall/services/dist/PaidDomainsApiClient'
import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { PaymentShopBlockedTransactionsApiClient } from '@fourthwall/services/dist/PaymentShopBlockedTransactionsApiClient'
import { PayoutApiClient } from '@fourthwall/services/dist/PayoutApiClient'
import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { ProductCatalogApiClient } from '@fourthwall/services/dist/ProductCatalogApiClient'
import { PromotionsApiClient } from '@fourthwall/services/dist/PromotionsApiClient'
import { PublicTokenApiClient } from '@fourthwall/services/dist/PublicTokenApiClient'
import { RealtimeStatsApiClient } from '@fourthwall/services/dist/RealtimeStatsApiClient'
import { ReportsApiClient } from '@fourthwall/services/dist/ReportsApiClient'
import { SaasApiClient } from '@fourthwall/services/dist/SaasApiClient'
import { SamplesBudgetApiClient } from '@fourthwall/services/dist/SamplesBudgetApiClient'
import { ShippingApiClient } from '@fourthwall/services/dist/ShippingApiClient'
import { ShippingProfilesApiClient } from '@fourthwall/services/dist/ShippingProfilesApiClient'
import { ShipstationIntegrationApiClient } from '@fourthwall/services/dist/ShipstationIntegrationApiClient'
import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { ShopRendererDraftBlocksApiClient } from '@fourthwall/services/dist/ShopRendererDraftBlocksApiClient'
import { ShopRendererDraftNavigationApiClient } from '@fourthwall/services/dist/ShopRendererDraftNavigationApiClient'
import { ShopRendererMembershipsApiClient } from '@fourthwall/services/dist/ShopRendererMembershipsApiClient'
import { ShopRendererOfferApiClient } from '@fourthwall/services/dist/ShopRendererOfferApiClient'
import { ShopRendererProductTemplateApiClient } from '@fourthwall/services/dist/ShopRendererProductTemplateApiClient'
import { ShopRendererThemeSettingsApiClient } from '@fourthwall/services/dist/ShopRendererThemeSettingsApiClient'
import { ShopRendererThemesApiClient } from '@fourthwall/services/dist/ShopRendererThemesApiClient'
import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { StockApiClient } from '@fourthwall/services/dist/StockApiClient'
import { ThankYouCardApiClient } from '@fourthwall/services/dist/ThankYouCardApiClient'
import { ThemeEditorApiClient } from '@fourthwall/services/dist/ThemeEditorApiClient'
import { ThirdPartyApiClient } from '@fourthwall/services/dist/ThirdPartyApiClient'
import { ThirdPartyLogisticsApiClient } from '@fourthwall/services/dist/ThirdPartyLogisticsApiClient'
import { UserApiClient } from '@fourthwall/services/dist/UserApiClient'
import { UserSecurityApiClient } from '@fourthwall/services/dist/UserSecurityApiClient'
import { WebhooksApiClient } from '@fourthwall/services/dist/WebhooksApiClient'
import { YouTubeMerchantCenterApiClient } from '@fourthwall/services/dist/YouTubeMerchantCenterApiClient'

export const API_CLIENTS = [
  AgencyApiClient,
  AIKitApiClient,
  AnalyticsApiClient,
  BespokeProductsApiClient,
  BillingApiClient,
  CollectionsApiClient,
  CreatorIntegrationsApiClient,
  CreatorIntegrationsV2ApiClient,
  CreatorMobilizationApiClient,
  CreatorSupportChannelsApiClient,
  CustomizationApiClient,
  CustomizationV4ApiClient,
  DashboardApiClient,
  DashboardV2ApiClient,
  DnsApiClient,
  DonationApiClient,
  FulfillmentsApiClient,
  GiftsApiClient,
  GiftCardsApiClient,
  GiveawayConfigApiClient,
  GiveawayContributionApiClient,
  GoogleAnalyticsConfigurationApiClient,
  HarmonisedSystemCodeApiClient,
  HasuraApiClient,
  InternalApiClient,
  KudosApiClient,
  MembershipsApiClient,
  MembershipsBadgesApiClient,
  MembershipsCreatorApiClient,
  MembershipsCreatorV2ApiClient,
  MembershipsDirectMessagesApiClient,
  MembershipsSpotifyIntegrationsApiClient,
  MetaConversionsApiClient,
  MetaPartnerApiClient,
  MetaPartnerProductsApiClient,
  NotificationPreferencesApiClient,
  NotificationShopPreferencesApiClient,
  OfferListingApiClient,
  OffersApiClient,
  OffersV2ApiClient,
  OfferCategoryApiClient,
  OffersCombinedApiClient,
  OffersBundleApiClient,
  OffersGiftCardApiClient,
  OnboardingApiClient,
  OpenAPIApiClient,
  OrderAnalyticsApiClient,
  OrderApiClient,
  PaidDomainsApiClient,
  PaymentApiClient,
  PaymentShopBlockedTransactionsApiClient,
  PayoutApiClient,
  PlatformAppsApiClient,
  ProductCatalogApiClient,
  PromotionsApiClient,
  PublicTokenApiClient,
  RealtimeStatsApiClient,
  ReportsApiClient,
  SamplesBudgetApiClient,
  SaasApiClient,
  ShippingApiClient,
  ShippingProfilesApiClient,
  ShipstationIntegrationApiClient,
  ShopRendererApiClient,
  ShopRendererDraftApiClient,
  ShopRendererDraftBlocksApiClient,
  ShopRendererDraftNavigationApiClient,
  ShopRendererMembershipsApiClient,
  ShopRendererOfferApiClient,
  ShopRendererProductTemplateApiClient,
  ShopRendererThemeSettingsApiClient,
  ShopRendererThemesApiClient,
  ShopUsersApiClient,
  ShopsApiClient,
  StockApiClient,
  ThemeEditorApiClient,
  ThirdPartyApiClient,
  ThirdPartyLogisticsApiClient,
  UserApiClient,
  UserSecurityApiClient,
  WebhooksApiClient,
  YouTubeMerchantCenterApiClient,
  ThankYouCardApiClient,
]
